import Swiper, { Navigation, Pagination } from 'swiper';
import $ from 'jquery';

function initBlockWithSeparatedCarouselAndTabs() {
  const keyCodesAvailable = [undefined, 1, 13, 32];
  document.querySelectorAll('.location-carousel').forEach((slider) => {
    const sliderContainers = slider.querySelectorAll('.location-carousel__swiper-container');
    Array.from(sliderContainers).forEach((container, index) => {
      const swiperItem = new Swiper(container, {
        slidesPerView: 3,
        spaceBetween: 30,
        autoHeight: true,
        modules: [Navigation, Pagination],
        speed: 700,
        navigation: {
          nextEl: container.querySelector('.location-carousel__nav--next'),
          prevEl: container.querySelector('.location-carousel__nav--prev'),
        },
        pagination: {
          el: container.querySelector('.location-carousel__swiper-pagination'),
        },
        breakpoints: {
          992: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
          320: {
            slidesPerView: 1,
          },
        },
      });

      const sliderTabsInside = slider.querySelectorAll('.location-carousel__name');
      const sliderTabsWrapper = slider.querySelector('.location-carousel__tabs');

      for (let i = 0; i < sliderTabsInside.length; i++) {
        const newTab = document.createElement('li');
        newTab.classList.add('location-carousel__tab');
        newTab.setAttribute('data-index', i);
        newTab.setAttribute('tabindex', 0);
        newTab.textContent = sliderTabsInside[i].textContent;
        sliderTabsWrapper.append(newTab);

        if (newTab.textContent <= 0) {
          newTab.classList.add('location-carousel__tab--empty');
        }

        sliderTabsInside[i].remove();
      }

      const sliderTabs = slider.querySelectorAll('.location-carousel__tab');

      for (let i = 0; i < sliderTabs.length; i++) {
        sliderTabs[0].classList.add('active');

        $(sliderTabs[i]).on('click keyup', (event) => {
          if (keyCodesAvailable.indexOf(event.keyCode) !== -1) {
            sliderTabs.forEach((elem) => elem.classList.remove('active'));
            sliderTabs[i].classList.add('active');
            sliderContainers.forEach((elem) => elem.style.display = 'none');
            document.querySelector(`.location-carousel__swiper-container--${i + 1}`).style.display = 'block';
          }
        });
      }
    });
  });
}

$(window).on('load resize', () => {
  initBlockWithSeparatedCarouselAndTabs();
});
